import { render, staticRenderFns } from "./PageSkeleton.vue?vue&type=template&id=43373c9a&scoped=true"
import script from "./PageSkeleton.vue?vue&type=script&lang=js"
export * from "./PageSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PageSkeleton.vue?vue&type=style&index=0&id=43373c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43373c9a",
  null
  
)

export default component.exports